export default __webpack_public_path__ + "static/media/ico_touch.478692cc.svg";